/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Phase_GenerateInputs */

const en_directory_submit_enrich_phase_generate = /** @type {(inputs: Directory_Submit_Enrich_Phase_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate`)
};

const zh_directory_submit_enrich_phase_generate = /** @type {(inputs: Directory_Submit_Enrich_Phase_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成`)
};

/**
* | output |
* | --- |
* | "Generate" |
*
* @param {Directory_Submit_Enrich_Phase_GenerateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_phase_generate = /** @type {((inputs?: Directory_Submit_Enrich_Phase_GenerateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Phase_GenerateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_phase_generate(inputs)
	return zh_directory_submit_enrich_phase_generate(inputs)
});
export { directory_submit_enrich_phase_generate as "directory.submit.enrich.phase.generate" }